module.exports = __webpack_public_path__ + "static/media/newsheet.23ddc08b.png";